export const LOCALE_GROUPS = {
  APPLICATION_DRY: 'area-density.application.dry-fertilizer',
  APPLICATION_LIQUID: 'volumetric-density',
  AREA: 'area',
  CROP_WATER_USE: 'crop-water-use',
  CROP_HEAT_INDEX: 'crop-heat-index',
  ELEVATION: 'elevation',
  EQUIPMENT_SPEED: 'land-speed',
  MOISTURE: 'humidity',
  POPULATION: 'seed-density',
  POPULATION_SHORT: 'seed-density.seed-density-short',
  POPULATION_WEIGHT: 'seed-density.air-seeder',
  RAINFALL: 'rainfall',
  WEIGHT: 'mass',
  YIELD: 'area-density.yield',
  YIELD_SILAGE: 'yield-density-weighted-crop-silage',
  YIELD_SUGARCANE: 'yield-density-weighted-crop-sugarcane',
  YIELD_COTTON: 'yield-density-weighted-crop-cotton',
};

export const POPULATION_WEIGHT_UNITS = {
  FVP: 'LBS_PER_ACRE',
  PLANTING: 'kg/hectare',
  PLANTING_ABBREVIATED: 'kg/ha',
};

export const FVP_APPLICATION_DRY_UNITS = 'POUNDS_PER_ACRES';

export const HARVEST_YIELD_UNITS = {
  BUSHELS_PER_ACRE: 'bu/ac',
  SHORTTONS_PER_HECTARE: 'tonne/hectare',
  METRICTONS_PER_HECTARE: 'mT/ha',
}
